import React from "react";
import { useLanguage } from "../i18n/LanguageContext";
import { translations } from "../i18n/translations";

export default function About() {
  const { t } = useLanguage();
  const tx = translations.about;

  return (
    <section id="residencia" className="bg-[#F5F0E8] py-24 lg:py-36">
      <div className="max-w-[1280px] mx-auto px-6 lg:px-12">
        <div className="flex items-center justify-center gap-4 mb-10">
          <div className="h-[1px] w-10 bg-[#9C8456]" />
          <span
            className="text-[#9C8456] text-[11px] tracking-[0.45em] uppercase"
            style={{ fontFamily: "'Jost', sans-serif", fontWeight: 400 }}
          >
            {t(tx.eyebrow)}
          </span>
          <div className="h-[1px] w-10 bg-[#9C8456]" />
        </div>

        <h2
          className="text-center text-[#2A2A28] text-[34px] sm:text-[48px] lg:text-[58px] leading-[1.1] mb-14 max-w-4xl mx-auto"
          style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 300 }}
        >
          {t(tx.title1)}
          <br className="hidden sm:block" />
          <em className="italic"> {t(tx.title2)}</em>
        </h2>

        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          <div className="lg:col-span-6 space-y-6">
            <p
              className="text-[#3a3a36] text-[16px] lg:text-[18px] leading-[1.85]"
              style={{ fontFamily: "'Jost', sans-serif", fontWeight: 300 }}
            >
              {t(tx.p1)}
            </p>
            <p
              className="text-[#3a3a36] text-[16px] lg:text-[18px] leading-[1.85]"
              style={{ fontFamily: "'Jost', sans-serif", fontWeight: 300 }}
            >
              {t(tx.p2)}
            </p>
          </div>
          <div className="lg:col-span-6 space-y-6">
            <p
              className="text-[#3a3a36] text-[16px] lg:text-[18px] leading-[1.85]"
              style={{ fontFamily: "'Jost', sans-serif", fontWeight: 300 }}
            >
              {t(tx.p3)}
            </p>
            <p
              className="text-[#3a3a36] text-[16px] lg:text-[18px] leading-[1.85] italic border-l-2 border-[#9C8456] pl-6"
              style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 400 }}
            >
              {t(tx.quote)}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
